export default function About() {
  const stats = [
    { number: '25+', label: 'YEARS', description: 'Combined Experience' },
    { number: '200+', label: 'CLIENTS', description: 'Served Monthly' },
    { number: '98%', label: 'SATISFACTION', description: 'Client Rating' },
    { number: '100%', label: 'COMMUNITY', description: 'First Always' }
  ];

  return (
    <section id="about" className="py-24 bg-neutral-950">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-5 gap-12 items-start">
          <div className="md:col-span-2">
            <p className="text-amber-500 text-sm font-bold tracking-wider mb-8">OUR STORY</p>
            <div className="grid grid-cols-2 gap-6">
              {stats.map((stat, index) => (
                <div key={index} className="bg-neutral-900 border border-neutral-800 p-6 rounded-lg">
                  <div className="text-4xl font-black text-amber-500 mb-2">{stat.number}</div>
                  <div className="text-sm font-bold text-white mb-1">{stat.label}</div>
                  <div className="text-xs text-stone-500">{stat.description}</div>
                </div>
              ))}
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="prose prose-lg max-w-none">
              <p className="text-stone-300 text-xl leading-relaxed mb-6">
                Nappy Rootz was born from a vision to create more than just a barbershop—we wanted to build a sanctuary where Black men could feel celebrated, understood, and empowered. Our name honors the natural beauty of our hair and the deep roots we have in our community.
              </p>
              <p className="text-stone-400 text-lg leading-relaxed mb-6">
                Founded by master barber Tevin Ryans who grew up in this neighborhood, Tevin brings decades of combined experience and an unwavering commitment to excellence. Every cut, every conversation, every moment here is about uplifting our brothers and preserving the rich tradition of Black barbering.
              </p>
              <p className="text-stone-400 text-lg leading-relaxed">
                We're not just cutting hair—we're building confidence, fostering connections, and keeping our culture alive one client at a time. When you sit in our chair, you're family.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}